import React from 'react';
import ReactDOM from 'react-dom';
import { Provider as MobxProvider } from 'mobx-react';
import { BrowserRouter } from 'react-router-dom';

// import { spy } from 'mobx';

// spy((event) => {
//     console.log('event', event);
// });

import * as serviceWorker from './serviceWorker';
import rootStore from '@/store/';


import "./init";
import App from './App.jsx';

ReactDOM.render(
    <MobxProvider {...rootStore}>
        <BrowserRouter >
            <App />
        </BrowserRouter>
    </MobxProvider>,
    document.getElementById('app'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
